import styled from 'styled-components';
import { PathwaySelector } from '../../common/components/ConsultTypeSelection/PathwaySelector';
import { DisplayCardContainer } from '../../common/components/cards/DisplayCard/DisplayCard.styles';
import { FLEX_COLS } from '../../common/components/layout/FlexLayout';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { Breakpoint } from '../../common/styles/constants';
import { GPButtonTypes } from './GPHomepageCard';

export const GPCardContainer = styled.div<{
  active?: boolean;
  type: number;
}>`
  background-color: ${ThemeColours.white};
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 5px;
  color: ${ThemeColours.mono800};
  flex: 1;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  transition: background-color 0.3s, color 0.3s, border 0.3s;

  &:first-child {
    margin-right: 20px;
  }

  &:hover {
    border: 1px solid ${ThemeColours.primary300};
    cursor: pointer;
  }

  ${Breakpoint.SMALL} {
    background-color: ${props =>
      props.active
        ? props.type === GPButtonTypes.GP
          ? ThemeColours.primary500
          : ThemeColours.accent200
        : ThemeColours.white};
    color: ${props => (props.active ? ThemeColours.white : ThemeColours.mono800)};
  }
`;

export const StyledGPCardContainer = styled.div``;

export const StyledGPCard = styled(PathwaySelector)<{ active?: boolean; type?: number }>`
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 5px;
  word-wrap: break-word;

  ${DisplayCardContainer} {
    padding-left: 16px;
    padding-right: 19px;
    padding-top: 20px;
  }

  &:hover {
    border: 1px solid ${ThemeColours.primary300};
    cursor: pointer;
  }

  ${Breakpoint.SMALL} {
    background-color: ${props =>
      props.active
        ? props.type === GPButtonTypes.GP
          ? ThemeColours.primary500
          : ThemeColours.accent200
        : ThemeColours.white};
    color: ${props => (props.active ? ThemeColours.white : ThemeColours.mono800)};
    transition: background-color 0.3s, color 0.3s, border 0.3s;
  }

  ${Breakpoint.MEDIUM} {
    padding-right: 65px;
  }
`;

export const GPHomepageCardsContainer = styled.div`
  ${FLEX_COLS}
  column-gap: 16px;
  flex: 1;
  flex-flow: wrap;
  justify-content: center;
  margin-bottom: 20px;
  margin-left: -16px;
  margin-right: -16px;

  ${Breakpoint.SMALL} {
    column-gap: 20px;
  }
`;
